module.exports = __webpack_public_path__ + "files/b5fad5c067d3eee5885c87d19beb6789.png";